import { IResultLayer } from '../core/interfaces/result.interface';

export const LAYER_TYPES = {
  Line: 'line',
  Fill: 'fill',
  Circle: 'circle',
} as const;

export const LAYER_NAMES = {
  Habitats: 'Habitat',
  Distinctiveness: 'Distinctiveness',
  Hedgerows: 'Hedgerows',
  Watercourses: 'Watercourses',
} as const;

export const isLinearLayer = (layer: IResultLayer) =>
  layer.displayName === LAYER_NAMES.Hedgerows || layer.displayName === LAYER_NAMES.Watercourses;

/**
 * Sorts layer classes in descending order by the first info value (Area or Length)
 * @param layer - The layer to sort
 * @returns A new layer object with sorted classes
 */
export const sortLayerClasses = (layer: IResultLayer): IResultLayer => {
  if (!layer?.details?.classes) return layer;

  return {
    ...layer,
    details: {
      ...layer.details,
      classes: [...layer.details.classes].sort((a, b) => {
        const aValue = Number(a.infoValues[0]) || 0;
        const bValue = Number(b.infoValues[0]) || 0;
        return bValue - aValue; // Descending order
      }),
    },
  };
};
